<template>
  <div>
    <v-layout>
      <v-flex>
        <v-tabs
          grow
          v-model="activeTab"
          :show-arrows="false"
          color="cardgray"
          slider-color="primary"
          >
          <v-tab 
            v-for="tab in tabs" 
            :key="tab.title" 
            :href="`#${tab.title}`" 
            >
            {{ tab.title }}
          </v-tab>
        </v-tabs>

        <v-tabs-items v-model="activeTab">

          <v-tab-item :id="`Explore`">
            <v-card>
              <data-explore></data-explore>
            </v-card>
          </v-tab-item>

          <v-tab-item :id="`Format`">
            <v-card>
              <data-format></data-format>
            </v-card>
          </v-tab-item>

          <v-tab-item :id="`Download`">
            <v-card>
              <data-download></data-download>
            </v-card>
          </v-tab-item>

        </v-tabs-items>

      </v-flex>
    </v-layout>
  </div>

</template>

<script>
  import DataExplore from './DataExplore'
  import DataFormat from './DataFormat'
  import DataDownload from './DataDownload'

  export default {
    name: 'Data',
    components: {
      'data-explore': DataExplore,
      'data-format': DataFormat,
      'data-download': DataDownload
    },
    data () {
      return {
        activeTab: 'Explore',  // by default start with the explore tab
        tabs: [
          { route: '/data-explore', title: 'Explore', key: 1 },
          { route: '/data-format', title: 'Format', key: 2 },
          { route: '/data-download', title: 'Download', key: 3 }
        ],
        route2tab: {
          '/data-explore': 'Explore',
          '/data-format': 'Format',
          '/data-download': 'Download'
        }
        // routeName: this.$route.params.name
      }
    },
    watch: {
      '$route.path': function (incomingPath) {
        this.activeTab = this.route2tab[incomingPath]
      }
    },

    created () {
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/Challenge/Data.vue